var isMobile = {
    Android: function () {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function () {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function () {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function () {
        return navigator.userAgent.match(/IEMobile/i);
    },
    any: function () {
        return (
            isMobile.Android() ||
            isMobile.BlackBerry() ||
            isMobile.iOS() ||
            isMobile.Opera() ||
            isMobile.Windows()
        );
    },
};

/**
 * @license
 * Lodash (Custom Build) lodash.com/license | Underscore.js 1.8.3 underscorejs.org/LICENSE
 * Build: `lodash include="debounce,throttle"`
 */
(function () {
    function t() {}

    function e(t) {
        return null == t ? (t === l ? d : y) : I && I in Object(t) ? n(t) : r(t);
    }

    function n(t) {
        var e = $.call(t, I),
            n = t[I];
        try {
            t[I] = l;
            var r = true;
        } catch (t) {}
        var o = _.call(t);
        return r && (e ? (t[I] = n) : delete t[I]), o;
    }

    function r(t) {
        return _.call(t);
    }

    function o(t, e, n) {
        function r(e) {
            var n = d,
                r = g;
            return (d = g = l), (x = e), (v = t.apply(r, n));
        }

        function o(t) {
            return (x = t), (O = setTimeout(c, e)), T ? r(t) : v;
        }

        function i(t) {
            var n = t - h,
                r = t - x,
                o = e - n;
            return w ? k(o, j - r) : o;
        }

        function f(t) {
            var n = t - h,
                r = t - x;
            return h === l || n >= e || n < 0 || (w && r >= j);
        }

        function c() {
            var t = D();
            return f(t) ? p(t) : ((O = setTimeout(c, i(t))), l);
        }

        function p(t) {
            return (O = l), S && d ? r(t) : ((d = g = l), v);
        }

        function s() {
            O !== l && clearTimeout(O), (x = 0), (d = h = g = O = l);
        }

        function y() {
            return O === l ? v : p(D());
        }

        function m() {
            var t = D(),
                n = f(t);
            if (((d = arguments), (g = this), (h = t), n)) {
                if (O === l) return o(h);
                if (w) return (O = setTimeout(c, e)), r(h);
            }
            return O === l && (O = setTimeout(c, e)), v;
        }
        var d,
            g,
            j,
            v,
            O,
            h,
            x = 0,
            T = false,
            w = false,
            S = true;
        if (typeof t != 'function') throw new TypeError(b);
        return (
            (e = a(e) || 0),
            u(n) &&
                ((T = !!n.leading),
                (w = 'maxWait' in n),
                (j = w ? M(a(n.maxWait) || 0, e) : j),
                (S = 'trailing' in n ? !!n.trailing : S)),
            (m.cancel = s),
            (m.flush = y),
            m
        );
    }

    function i(t, e, n) {
        var r = true,
            i = true;
        if (typeof t != 'function') throw new TypeError(b);
        return (
            u(n) &&
                ((r = 'leading' in n ? !!n.leading : r),
                (i = 'trailing' in n ? !!n.trailing : i)),
            o(t, e, {
                leading: r,
                maxWait: e,
                trailing: i,
            })
        );
    }

    function u(t) {
        var e = typeof t;
        return null != t && ('object' == e || 'function' == e);
    }

    function f(t) {
        return null != t && typeof t == 'object';
    }

    function c(t) {
        return typeof t == 'symbol' || (f(t) && e(t) == m);
    }

    function a(t) {
        if (typeof t == 'number') return t;
        if (c(t)) return s;
        if (u(t)) {
            var e = typeof t.valueOf == 'function' ? t.valueOf() : t;
            t = u(e) ? e + '' : e;
        }
        if (typeof t != 'string') return 0 === t ? t : +t;
        t = t.replace(g, '');
        var n = v.test(t);
        return n || O.test(t) ? h(t.slice(2), n ? 2 : 8) : j.test(t) ? s : +t;
    }
    var l,
        p = '4.17.4',
        b = 'Expected a function',
        s = NaN,
        y = '[object Null]',
        m = '[object Symbol]',
        d = '[object Undefined]',
        g = /^\s+|\s+$/g,
        j = /^[-+]0x[0-9a-f]+$/i,
        v = /^0b[01]+$/i,
        O = /^0o[0-7]+$/i,
        h = parseInt,
        x = typeof global == 'object' && global && global.Object === Object && global,
        T = typeof self == 'object' && self && self.Object === Object && self,
        w = x || T || Function('return this')(),
        S = typeof exports == 'object' && exports && !exports.nodeType && exports,
        N = S && typeof module == 'object' && module && !module.nodeType && module,
        E = Object.prototype,
        $ = E.hasOwnProperty,
        _ = E.toString,
        W = w.Symbol,
        I = W ? W.toStringTag : l,
        M = Math.max,
        k = Math.min,
        D = function () {
            return w.Date.now();
        };
    (t.debounce = o),
        (t.throttle = i),
        (t.isObject = u),
        (t.isObjectLike = f),
        (t.isSymbol = c),
        (t.now = D),
        (t.toNumber = a),
        (t.VERSION = p),
        typeof define == 'function' && typeof define.amd == 'object' && define.amd
            ? ((w._ = t),
              define(function () {
                  return t;
              }))
            : N
            ? (((N.exports = t)._ = t), (S._ = t))
            : (w._ = t);
}).call(this);

// Confetti - modified from: https://github.com/daniel-lundin/dom-confetti
var defaultColors3 = ['#ffffff', '#ffffff', '#ffffff'];

function createElements(root, elementCount, colors, width, height) {
    return Array.from({
        length: elementCount,
    }).map(function (_, index) {
        var element = document.createElement('div');
        var color = colors[index % colors.length];
        element.style['background-color'] = color; // eslint-disable-line space-infix-ops

        element.style.width = width;
        element.style.height = height;
        element.style.position = 'absolute';
        element.style.willChange = 'transform, opacity';
        element.style.visibility = 'hidden';
        root.appendChild(element);
        return element;
    });
}

function randomPhysics(angle, spread, startVelocity, random) {
    var radAngle = angle * (Math.PI / 180);
    var radSpread = spread * (Math.PI / 180);
    return {
        x: 0,
        y: 0,
        z: 0,
        wobble: random() * 10,
        wobbleSpeed: 0.1 + random() * 0.1,
        velocity: startVelocity * 0.5 + random() * startVelocity,
        angle2D: -radAngle + (0.5 * radSpread - random() * radSpread),
        angle3D: -(Math.PI / 4) + random() * (Math.PI / 2),
        tiltAngle: random() * Math.PI,
        tiltAngleSpeed: 0.1 + random() * 0.3,
    };
}

function updateFetti(fetti, progress, dragFriction, decay) {
    /* eslint-disable no-param-reassign */
    fetti.physics.x += Math.cos(fetti.physics.angle2D) * fetti.physics.velocity;
    fetti.physics.y += Math.sin(fetti.physics.angle2D) * fetti.physics.velocity;
    fetti.physics.z += Math.sin(fetti.physics.angle3D) * fetti.physics.velocity;
    fetti.physics.wobble += fetti.physics.wobbleSpeed; // Backward compatibility

    if (decay) {
        fetti.physics.velocity *= decay;
    } else {
        fetti.physics.velocity -= fetti.physics.velocity * dragFriction;
    }

    fetti.physics.y += 3;
    fetti.physics.tiltAngle += fetti.physics.tiltAngleSpeed;
    var _fetti$physics = fetti.physics;
    var x = _fetti$physics.x;
    var y = _fetti$physics.y;
    var z = _fetti$physics.z;
    var tiltAngle = _fetti$physics.tiltAngle;
    var wobble = _fetti$physics.wobble;

    var wobbleX = x + 10 * Math.cos(wobble);
    var wobbleY = y + 10 * Math.sin(wobble);
    var transform =
        'translate3d(' +
        wobbleX +
        'px, ' +
        wobbleY +
        'px, ' +
        z +
        'px) rotate3d(1, 1, 1, ' +
        tiltAngle +
        'rad)';
    fetti.element.style.visibility = 'visible';
    fetti.element.style.transform = transform;
    fetti.element.style.opacity = 1 - progress;
    /* eslint-enable */
}

function animate(root, fettis, dragFriction, decay, duration, stagger) {
    var startTime = void 0;
    return new Promise(function (resolve) {
        function update(time) {
            if (!startTime) startTime = time;
            var elapsed = time - startTime;
            var progress = startTime === time ? 0 : (time - startTime) / duration;
            fettis.slice(0, Math.ceil(elapsed / stagger)).forEach(function (fetti) {
                updateFetti(fetti, progress, dragFriction, decay);
            });

            if (time - startTime < duration) {
                requestAnimationFrame(update);
            } else {
                fettis.forEach(function (fetti) {
                    if (fetti.element.parentNode === root) {
                        return root.removeChild(fetti.element);
                    }
                });
                resolve();
            }
        }

        requestAnimationFrame(update);
    });
}

var defaults4 = {
    angle: 90,
    spread: 45,
    startVelocity: 45,
    elementCount: 50,
    width: '4px',
    height: '4px',
    perspective: '',
    colors: defaultColors3,
    duration: 9000,
    stagger: 0,
    dragFriction: 0.7,
    random: Math.random,
};

function backwardPatch(config) {
    if (!config.stagger && config.delay) {
        config.stagger = config.delay;
    }

    return config;
}

window.throwConfetti = function (root) {
    //console.log('Root: ' + root); // For debugging
    if (!root) {
        console.error('Root element is not defined.');
        return;
    }
    var config = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    var _Object$assign = Object.assign({}, defaults4, backwardPatch(config));

    var elementCount = _Object$assign.elementCount;
    var colors = _Object$assign.colors;
    var width = _Object$assign.width;
    var height = _Object$assign.height;
    var perspective = _Object$assign.perspective;
    var angle = _Object$assign.angle;
    var spread = _Object$assign.spread;
    var startVelocity = _Object$assign.startVelocity;
    var decay = _Object$assign.decay;
    var dragFriction = _Object$assign.dragFriction;
    var duration = _Object$assign.duration;
    var stagger = _Object$assign.stagger;
    var random = _Object$assign.random;

    root.style.perspective = perspective;
    var elements = createElements(root, elementCount, colors, width, height);
    var fettis = elements.map(function (element) {
        return {
            element: element,
            physics: randomPhysics(angle, spread, startVelocity, random),
        };
    });
    return animate(root, fettis, dragFriction, decay, duration, stagger);
};



function mixpanelClearFilter() {

    var currentUrl = window.location.href;

    // Find the index of "collections/" in the URL
    var startIndex = currentUrl.indexOf("collections/") + "collections/".length;

    // Find the index of "/" after the collection name
    var endIndex = currentUrl.indexOf("/", startIndex);

    // Extract the substring between "collections/" and the next "/"
    var collectionName = currentUrl.substring(startIndex, endIndex !== -1 ? endIndex : undefined);
    collectionName = collectionName.split(/[?/]/)[0];

    var refurl = document.referrer || ""; // Ensure referrer is defined

    mixpanel.track("Filter Cleared", {
        "Page URL": currentUrl,
        "Referrer URL": refurl,
        "Collection": collectionName
    });

    //console.log('Filter cleared');
}

function mixpanelFilterApplied(filterText, headingText) {
    var currentUrl = window.location.href;
    var startIndex = currentUrl.indexOf("collections/") + "collections/".length;
    var endIndex = currentUrl.indexOf("/", startIndex);
    var collectionName = currentUrl.substring(startIndex, endIndex !== -1 ? endIndex : undefined);
collectionName = collectionName.split(/[?/]/)[0];

    var refurl = document.referrer || ""; // Ensure referrer is defined

    mixpanel.track("Filter Selected", {
        "Filter Name": headingText,
        "Filter Value": filterText,
        "Page URL": currentUrl,
        "Referrer URL": refurl,
        "Collection": collectionName
    });

    //console.log('Filter name: ' + headingText + ', Filter value: ' + filterText);
}

function mixpanelSortCompleted(sortOptionText) {
        var currentUrl = window.location.href;
        var startIndex = currentUrl.indexOf("collections/") + "collections/".length;
        var endIndex = currentUrl.indexOf("/", startIndex);
        var collectionName = currentUrl.substring(startIndex, endIndex !== -1 ? endIndex : undefined);

        var refurl = document.referrer || ""; // Ensure referrer is defined

        mixpanel.track("Sort Completed", {
            "Selected Option": sortOptionText,
            "Page Url": currentUrl,
            "Collection Name": collectionName,
            "Referrer URL": refurl
        });
}

function autoImageHover(productHoverHandle) {
    // This function is kept for backward compatibility
    // It directly uses ProductImageLoader when available
    if (window.productImageLoader) {
        const productCard = document.querySelector(`.plp-auto-hover[data-frame-handle="${productHoverHandle}"]`);
        if (productCard) {
            window.productImageLoader.startCycle(productCard);
        }
    } else {
        console.warn('ProductImageLoader not found - image cycling disabled');
    }
}

window.addEventListener('load', (event) => {
    // If ProductImageLoader is available, it will handle all auto-hover products
    // Otherwise, use the old approach
    if (!window.productImageLoader) {
        $('.plp-auto-hover').each(function () {
            var productHoverHandle = $(this).data('frame-handle');
            autoImageHover(productHoverHandle);
        });
    }
});



function loadJSONcollection(familyCollectionHandle, $visibleLazyProduct) {
    $.ajax({
        url: '/collections/' + familyCollectionHandle + '?view=family',
        type: 'GET',
    })
        .done(function (data) {
            $visibleLazyProduct.find('.plp-grid-items-wrapper').append(data);
        })
        .fail(function (data) {})
        .always(function (data) {});
}

const $windowHeight = $(window).height();

var plpSwatchHover = {
    init: function () {
        plpSwatchHover.bindEvents();
    },
    bindEvents: function () {
        var familyItemHover;
        $('.family-swatch-product a').hover(
            function () {
                var $this = $(this);
                var $card = $this.parents('.grid__item');
                var hoveredItemHandle = $this.data('product-handle');

                familyItemHover = setTimeout(function () {
                    //let $cardReviews = $card.find('.card-active').find('.pwr-category-snippets');
                    // console.log($cardReviews);
                    $card.find('.frame-active').removeClass('frame-active');
                    $this.parents('.family-swatch').addClass('frame-active');
                    $card.find('.card-active').removeClass('card-active');
                    $card
                        .find('.card-wrapper[data-frame-handle="' + hoveredItemHandle + '"]')
                        .addClass('card-active')
                        .attr('aria-hidden', 'true');
                    $(
                        'main .card-wrapper[data-frame-handle="' +
                            hoveredItemHandle +
                            '"] .product-card-details',
                    ).attr('aria-hidden', 'false');
                    
                    // Use ProductImageLoader directly
                    if (window.productImageLoader) {
                        window.productImageLoader.reinit();
                    }
                }, 200);
            },
            function () {
                clearTimeout(familyItemHover);
            },
        );
    },
};

onload = (event) => {
    if ($(window).width() > 990) {
        plpSwatchHover.init();
    }
};

function addInitialNumbersClasses() {
    $('main #product-grid .plp-product-standard:not(.brand-block-grid-collection-product)').each(function (i) {
        $(this).addClass('product--block-' + (i + 1));
    });
}

const originalCollectionURL = $('.collection-filter-groups').attr('data-collection-url');

let pagination_template_name = 'ajax-pagination';

if ($('body').hasClass('template-collection-brand-blocks-main')) {
    pagination_template_name = 'ajax-pagination-carousels';
}

var paginationIsLoading = !1;
(function () {
    $(document).on('click', '.js-pagination-load-more', function (event) {
        event.preventDefault();
        var $ajaxWrapper = $('#load-more-dump #product-grid');
        var ajaxURL = $(this).attr('href');

        // console.log('Ajax page URL: ' + ajaxURL);
        $.ajax({
            url: ajaxURL + '&view=' + pagination_template_name,
            dataType: 'html',
            beforeSend: function () {
                $('.spinner-gif').show();
            },
        }).done(function (data) {
            // check class added
            $('.spinner-gif').hide();
            var $pagination = $(data).find('.pagination-load-more');
            $('.pagination-load-more-wrapper').html($pagination);
            setTimeout(function () {
                if ($(window).width() > 990) {
                    plpSwatchHover.init();
                }
                
                // Use ProductImageLoader directly
                if (window.productImageLoader) {
                    window.productImageLoader.reinit();
                }
                
                $(function (event) {
                    if (window._swat) {
                        var swymDataElems = $('body').find('script.swym-product-view-snippet');
                        $(swymDataElems).appendTo(document.body);
                        setTimeout(function () {
                            window._swat.initializeActionButtons('.load-more-target');
                        }, 1000);
                    }
                });
            }, 500);
            var ajaxURLNext = $('.pagination-load-more').attr('href');
            if (!ajaxURLNext) {
                $('.pagination-load-more-wrapper').remove();
                $('body').addClass('collection-last-page-loaded');
                $('.pe--load-more').addClass('pe--show-button');
            }
            var $items = $(data).find('#load-more-dump #product-grid').children();
            $items
                .css('opacity', '0')
                .addClass('current-page')
                .prev('.current-page')
                .removeClass('current-page');

            $ajaxWrapper.append($items);

            addInitialNumbersClasses();

            if (deviceIsMobile.matches) {
                reorderBrandBlocks();
            }



            $('main .brand-block-half').each(function (i) {
                $(this).addClass('brand-block-half-' + (i + 1));
            });

            $items.animate(
                {
                    opacity: '1',
                },
                400,
            );

            //loadReviews();
            
            
            setTimeout(function() {
                window.dispatchEvent(new CustomEvent('feraWidgetsLoaded'));
            },3000);

            

            paginationIsLoading = !1;

            initializeGTMTracking($ajaxWrapper[0]);

            // Dispatch custom event for new pagination content
            window.dispatchEvent(new CustomEvent('paginationContentLoaded', {
                detail: { container: $ajaxWrapper[0] }
            }));

            setTimeout(function() {
                window.initializeTickers();
            }, 100);
        });
    });
    if ($('.pagination-style-scroll').length) {
        $(window).on(
            'scroll',
            _.throttle(
                function () {
                    var limit = 3 * $(window).height();
                    if ($(document).height() - $(window).scrollTop() < limit) {
                        if (!paginationIsLoading) {
                            paginationIsLoading = !0;
                            $('.pagination-load-more').trigger('click');

                            //console.log('Loading');
                        }
                    }
                },
                250,
                {
                    leading: !0,
                    trailing: !0,
                },
            ),
        );
    }
})();

function superBrandBlockCarousels() {
    if ($('.brand-block-grid').length) {

        $('.brand-block-grid').each(function(){
          var $this = $(this);
          var $thisSlider = $this.find('.brand-block-grid-collection-image');
          var $thisProducts = $this.find('.brand-block-grid-collection-products');
      
          // Initialize image slider if more than one image
          if ($thisSlider.find('.brand-block-grid-collection-image-inner').length > 1) {
            $thisSlider.slick({
              dots: true,
              autoplay: true,
              autoplaySpeed: 5000,
              pauseOnHover: false,
              fade: true,
              infinite: true,
              arrows: false,
              slidesToShow: 1,
              slidesToScroll: 1,
              easing: "ease",
              vertical: false
            }).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
              var $currentVideo = findVideo(currentSlide, slick);
              if ($currentVideo.length) {
                $currentVideo.get(0).pause();
                setTimeout(function(){
                  $currentVideo.get(0).currentTime = 0;  // Reset the video to the start
                },500)
              }
      
              var $nextVideo = findVideo(nextSlide, slick);
              if ($nextVideo.length) {
                $nextVideo.get(0).play();
                $thisSlider.slick('slickPause');
                 // Start playing next slide's video immediately
              }
            }).on('afterChange', function(event, slick, currentSlide) {
              var $video = findVideo(currentSlide, slick);
              if ($video.length) {
                $video.get(0).onended = function() {
                  $thisSlider.slick('slickPlay');
                  $thisSlider.slick('slickNext');  // Move to the next slide immediately after video ends
                };
              } else {
                // Ensure slider continues if there's no video
                $thisSlider.slick('slickPlay');
              }
            });
          }
      
      
          function findVideo(slideIndex, slick) {
            var $slide = $(slick.$slides[slideIndex]);
            var $video = $slide.find('video');
            if ($(window).width() > 768) {
              $video = $slide.find('video.krw--desktop-only');
            } else {
              $video = $slide.find('video.krw--mobile-only');
            }
      
            return $video.length ? $video : $slide.find('video'); // fallback to any video
          }
      
       
          if ($thisProducts.hasClass('brand-block-products-carousel') && $(window).width() > 991) {
            $thisProducts.slick({
              dots: false,
              autoplay: false,
              autoplaySpeed: 5000,
              pauseOnHover: false,
              fade: false,
              infinite: false,
              arrows: true,
              slidesToShow: 2,
              slidesToScroll: 2,
              easing: "ease",
              vertical: false
            });
      
          }
          
       });
      }
      
      if ($('.product-carousel').length) {
      
        $('.product-carousel').each(function(){
          var $this = $(this);
          var $thisSlider = $this.find('ul');
      
          if ($thisSlider.find('li').length > 1 && $(window).width() > 991) {
            $thisSlider.slick({
              dots: false,
              autoplay: false,
              pauseOnHover: false,
              fade: false,
              infinite: false,
              arrows: true,
              slidesToShow: 3,
              slidesToScroll: 1,
              easing: "ease",
              vertical: false
            });
          }
        });
       
      }
}

function reorderBrandBlocksPage1() {

    $('main #product-grid .card-brand-block:not(.last-product-brand-block)').each(function (i) {
        $(this).addClass('editorial--block-' + (i + 1));
    });

    if ($('.brand-block-number-1').hasClass('brand-block-grid-first')) {
        $('.editorial--block-2').insertAfter('.product--block-6');
        $('.editorial--block-3').insertAfter('.product--block-12');
        $('.editorial--block-4').insertAfter('.product--block-20');
        $('.editorial--block-5').insertAfter('.product--block-26');
        $('.editorial--block-6').insertAfter('.product--block-34');
        $('.editorial--block-7').insertAfter('.product--block-40');
    } else if (!$('body').hasClass('small-brand-blocks-collection')) {
        $('.editorial--block-1').insertAfter('.product--block-4');
        $('.editorial--block-2').insertAfter('.product--block-11');
        $('.editorial--block-3').insertAfter('.product--block-18');
        $('.editorial--block-4').insertAfter('.product--block-25');
        $('.editorial--block-5').insertAfter('.product--block-32');
        $('.editorial--block-6').insertAfter('.product--block-39');
        $('.editorial--block-7').insertAfter('.product--block-46');
    }
    
    
    $('body').removeClass('plp--hide-brand-blocks');
}

function reorderBrandBlocks(showFirstBrandBlockFirst) {

    $('.card-brand-block:not(.last-product-brand-block)').each(function (i) {
        $(this).addClass('editorial--block-' + (i + 1));
    });

    if ($('body').hasClass('brand-block-first') && $('body').hasClass('sale-area')) {
        $('.editorial--block-7').insertAfter('.product--block-46');
        $('.editorial--block-8').insertAfter('.product--block-53');
        $('.editorial--block-9').insertAfter('.product--block-60');
        $('.editorial--block-10').insertAfter('.product--block-67');
        $('.editorial--block-11').insertAfter('.product--block-74');
        $('.editorial--block-12').insertAfter('.product--block-81');
        $('.editorial--block-13').insertAfter('.product--block-88');
    } else {
        $('.brand-block-number-1').insertAfter('.product--block-4');
        $('.brand-block-number-2').insertAfter('.product--block-12');
        $('.brand-block-number-3').insertAfter('.product--block-20');
        $('.brand-block-number-4').insertAfter('.product--block-28');
        $('.brand-block-number-5').insertAfter('.product--block-36');
        $('.brand-block-number-6').insertAfter('.product--block-44');
    }

    $('body').removeClass('plp--hide-brand-blocks');
}

function updateCarousels() {
    //console.log('updateCarousels called');
    document.querySelectorAll('main .plp-carousel').forEach((carousel) => {
        const carouselId = carousel.dataset.carouselId;
        const slides = Array.from(carousel.querySelectorAll('img')); // Create an array of slides
        const track = document.querySelector(
            `main .carousel-track-wrapper[data-carousel-id="${carouselId}"] .carousel-track`,
        );
        const rectangle = track.querySelector('.carousel-rectangle');

        rectangle.style.width = `${track.offsetWidth / slides.length}px`;

        const trackWidth = track.offsetWidth - rectangle.offsetWidth;

        carousel.addEventListener('scroll', () => {
            const scrollLeft = carousel.scrollLeft;
            const scrollWidth = carousel.scrollWidth;
            const carouselWidth = carousel.offsetWidth;
            const scrollPercent = scrollLeft / (scrollWidth - carouselWidth);

            rectangle.style.transform = `translateX(${scrollPercent * trackWidth}px)`;
        });
    });
}

function ajaxLoadElements() {
    if ($(window).width() > 990) {
        plpSwatchHover.init();

        const familySwatchBars = document.querySelectorAll('.family-products-swatch-bar');

        if (familySwatchBars.length > 0) {
            familySwatchBars.forEach((swatchBar) => {
                const swatches = swatchBar.querySelector('.family-swatches');
                const swatchItems = swatches.querySelectorAll('.family-swatch-product');
                const plusSign = swatchBar.querySelector('.family-swatch.family-plus');

                if (swatchItems.length > 6 && plusSign) {
                    swatches.insertBefore(plusSign, swatchItems[6]);
                }
            });
        }

        // Use ProductImageLoader directly
        if (window.productImageLoader) {
            window.productImageLoader.reinit();
        }

    } else {
    }

    var ajaxURLNext = $('.pagination-load-more').attr('href');
    if (!ajaxURLNext) {
        $('.pagination-load-more-wrapper').remove();
        $('body').addClass('collection-last-page-loaded');
        $('.pe--load-more').addClass('pe--show-button');
    }

    $(document).on('click', 'a.product-card-plus', function (event) {
        var $this = $(this);

        event.preventDefault();
        $this
            .parents('.product-card')
            .find('.product-card-function-bar')
            .removeClass('hovering-plus');
    });

    var plusHoverTimer;
    $('a.product-card-plus').hover(
        function () {
            var $this = $(this);
            plusHoverTimer = setTimeout(function () {
                $this
                    .parents('.product-card')
                    .find('.product-card-function-bar')
                    .addClass('hovering-plus');
            }, 300);
        },
        function () {
            clearTimeout(plusHoverTimer);
        },
    );


}

$(document).on('click', '.filter-toggle', function () {
    var $this = $(this);

    if (!$('body').hasClass('gift-collection')) {
        if ($this.parent().hasClass('filter-opened')) {
            $this.find('.filters-toggle-icon span:not(.filters-toggle-icon-text)').text('CLOSE');
        } else {
            if ($(window).width() > 990) {
                $this
                    .find('.filters-toggle-icon span:not(.filters-toggle-icon-text)')
                    .html(
                        `<img src="${filterIcon}" role="presentation" alt="Filters">`,
                    );
            } else {
                $this
                    .find('.filters-toggle-icon span:not(.filters-toggle-icon-text)')
                    .text('FILTER');
            }
        }
    }

    $this.parent().toggleClass('filter-opened');
});

const filter_rail = document.querySelectorAll('[body-scroll-lock-ignore]');

$('.filters-toggle-btn').on('click', function () {
    var $this = $(this);
    if (!$('body').hasClass('gift-collection')) {
        if ($this.parents('.collection-refinement').hasClass('showing-filters')) {
            $this.find('.filters-toggle-icon span').text('FILTER');

            if ($(window).width() > 990) {
                $this
                    .find('.filters-toggle-icon span')
                    .html(
                        `<img src="${filterIcon}" role="presentation" alt="Filters">`,
                    );
            } else {
                $this.find('.filters-toggle-icon span').text('FILTER');
            }
        } else {
            $this.find('.filters-toggle-icon span').text('CLOSE');
        }
    }

    if (!$('.collection-refinement').hasClass('filter-is-selected')) {
        $('.filters-bar').toggleClass('show-filters-bar');
    }

    $('.collection-filter-groups').toggleClass('show-filters');
    $('.collection-refinement').toggleClass('showing-filters');

    $('body').toggleClass('collection-filters-showing');
});

function attachMarkYourCalendarEvents() {
    // Get all instances of .mark-your-calendar-brand-block
    const markYourCalendarBlocks = document.querySelectorAll('.mark-your-calendar-brand-block');

    markYourCalendarBlocks.forEach((markYourCalendarBlock) => {
        const tooltipPopup = markYourCalendarBlock.querySelector('.tooltip-popup');

        // Ensure tooltipPopup exists before proceeding
        if (tooltipPopup) {
            // Function to toggle show-tooltip-popup class on tooltip popup and show tooltip at clicked coordinates
            function toggleTooltipPopup(event) {
                // Calculate x and y relative to the markYourCalendarBlock
                const x = event.clientX - markYourCalendarBlock.getBoundingClientRect().left;
                const y = event.clientY - markYourCalendarBlock.getBoundingClientRect().top;

                tooltipPopup.style.position = 'absolute';
                tooltipPopup.style.left = x + 'px';
                tooltipPopup.style.top = y + 'px';
                tooltipPopup.classList.toggle('show-tooltip-popup');
            }

            // Add click event listener to markYourCalendarBlock
            markYourCalendarBlock.addEventListener('click', (event) => {
                toggleTooltipPopup(event);
            });
        }
    });

    // Add global event listeners for clicking outside and scrolling
    document.addEventListener('click', (event) => {
        if (!event.target.closest('.mark-your-calendar-brand-block')) {
            document.querySelectorAll('.mark-your-calendar-brand-block .tooltip-popup').forEach((popup) => {
                popup.classList.remove('show-tooltip-popup');
            });
        }
    });

    document.addEventListener('scroll', () => {
        document.querySelectorAll('.mark-your-calendar-brand-block .tooltip-popup').forEach((popup) => {
            popup.classList.remove('show-tooltip-popup');
        });
    });
}

// Call the attachMarkYourCalendarEvents function on document ready
document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelectorAll('.mark-your-calendar-brand-block').length) {
        attachMarkYourCalendarEvents();
    }
});

const cssClasses = {
    collectionSidebar: '.collection-sidebar',
    accordionHeading: '.filter-group:not(.sort-group)',
    accordionContent: '.accordion-content',
    filterItem: '.Linklist__Item:not(.sort-item)',
    sortItem: '.Linklist__Item.sort-item',
    filter: '.Linklist:not(.sort-list)',
};

// Accordion
const accordionHeading = $(cssClasses.accordionHeading);

var destroyButton = document.getElementById('destroy');
document.addEventListener('DOMContentLoaded', function () {
   // ajaxLoadElements();
    addInitialNumbersClasses();
});

accordionHeading.on('click', function () {
    const parentItem = $(this).parent();
    const content = parentItem.find(cssClasses.accordionContent).first();

    $(this).toggleClass('open');
    content.slideToggle();
});

// Tag filter
const url = window.location.origin + window.location.pathname;
const filterItem = $(cssClasses.filterItem);
let collectionUrl = $(cssClasses.collectionSidebar).data('collection-url');

const productsContainer = $('#ProductGridContainer #product-grid');
const productsContainerParent = $('#ProductGridContainer #load-more-dump');

filterItem.each(function () {
    const tag = $(this).data('tag');

    if (url.indexOf(tag) !== -1) {
        $(this).addClass('is-selected');

        //  console.log($(this), 'add class is-selected');

        const accordionHeading = $(this).parent().parent().find(cssClasses.accordionHeading);

        if (accordionHeading.length !== 0) {
            accordionHeading.trigger('click');
        }
    }
});

function checkNumberOfAdditionalProducts() {}

if (
    !$('.checkNumberOfAdditionalProducts').hasClass('hidden-get-more') &&
    $('body').hasClass('template-name-collection')
) {
    checkNumberOfAdditionalProducts();
}

let filtering_template_name = 'ajax-pagination';

if ($('body').hasClass('template-collection-brand-blocks-main')) {
    filtering_template_name = 'ajax-pagination-carousels';
}

function scrollToTop() {
    window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
    });
}

function scrollToTopFilterDesktop() {
    window.scrollTo({
        top: 62,
        left: 0,
        behavior: 'smooth',
    });
}

function loadReviews() {
    setTimeout(function(){
        yotpoWidgetsContainer.initWidgets();
        console.log('Reviews loading');
    },1000)
}

function checkFiltersAndSortSelection() {
    // Check if there are any selected sort items or main filters
    var isSelectedExists = $('.sort-item.is-selected, .main-filter.is-selected').length > 0;

    // If no selected sort items or main filters are found, remove the 'show-filters-bar' class
    if (!isSelectedExists) {
        $('.filters-bar').removeClass('show-filters-bar');
        $('.collection-refinement').removeClass('filter-is-selected');
        $('.filters-bar').removeClass('show-filters-bar');
    }
}

$(document).on('click', '.Linklist__Item:not(.sort-item)', function () {
    collectionUrl = $('.collection-filter-groups').attr('data-collection-url');

    let search = window.location.search;

    let filterText = $(this).text().trim();
    let headingText = $(this).closest('.filter-group').find('.filter-text').text().trim();

    

    if (search.indexOf('page') !== -1) {
        const pageParam = search.split('&')[0];
        search = search.replace(pageParam, '').replace('&', '?');
    }

    $('.filtered--count').text('');
    $('.filtered-loading').css('display', 'block');
    if ($(window).width() > 834 && $(window).scrollTop() != 0) {
        scrollToTopFilterDesktop();
    }

    if ($(window).width() < 834) {
        scrollToTop();
    }

    const filter = $(this).parents('[data-filter]');
    const filterItems = filter.find(cssClasses.filterItem);


    if ($(this).hasClass('is-selected')) {
    } else {
    }

    const tag_custom_name = $(this).attr('data-tag-add-on');

    $(this).toggleClass('is-selected').siblings().removeClass('is-selected');

    if (tag_custom_name != 'false') {
        $(this)
            .parents('.filter-group')
            .find('.filter-toggle em')
            .text(' ' + tag_custom_name);
    } else {
        $(this)
            .parents('.filter-group')
            .find('.filter-toggle em')
            .text(' ' + $(this).attr('data-gtm-label'));
    }

    if (!$(this).parents('.filter-group').find('.is-selected').length) {
        $(this).parents('.filter-group').find('.filter-toggle em').text('');
    }

    var activeItems = $('.collection-filter-groups').find(
        cssClasses.filterItem + '.is-selected',
    );
    var activeTags = [];

    activeItems.each(function (index, el) {
        var tag = $(el).attr('data-tag');

        if (tag) {
            activeTags.push(tag);
        }
    });

    var tagsUrl = activeTags.join('+');

    var newUrl = collectionUrl;

    if (tagsUrl) {
        newUrl += '/' + tagsUrl;
    }
    newUrl += search;
    // console.log(newUrl);
    // console.log('---');
    $('.collection-container').addClass('ajax-loading');
    $('.collection-filter-groups-inner').addClass('filtered-products-loading');

    var newUrlRequest = newUrl;

    if (newUrlRequest.indexOf('?') > -1) {
        // If URL already contains a "?" character, append the new parameter using "&"
        newUrlRequest += '&view=' + filtering_template_name;
    } else {
        // If URL does not contain a "?" character, append the new parameter using "?"
        newUrlRequest += '?view=' + filtering_template_name;
    }

    var filteredCollectionURL = $('.collection-filter-groups').attr('data-collection-url');

    $.get({
        url: newUrlRequest,
        success: function (data) {
            setTimeout(function () {
                $('.filters-bar').addClass('show-filters-bar');
                var newProductsWrapper = $(data).find('#product-grid');
                var newPagination = $(data).find('.pagination');
                var newPaginationHtml = newPagination.html();
                var newProductsHtml = newProductsWrapper.html();
                var newItemCount = newProductsWrapper.attr('data-products-count');
                if (newProductsHtml) {
                    productsContainer.html(newProductsHtml);
                    // console.log('Products found');
                } else {
                    let emptyCollection = $(data).find('#emptyCollection');
                    let emptyCollectionHTML = emptyCollection.html();
                    // console.log('no products found');

                    $('.pe--load-more').css('display', 'none');

                    productsContainer.empty();

                    if (emptyCollectionHTML) {
                        productsContainer.append(emptyCollectionHTML);
                    } else {
                        //  console.log('no products message found');
                        productsContainer.append(
                            '<div class="title-wrapper center"><h2 class="title title--primary">Oops, you stumped us!<br><a href="{{ collection.url }}" class="underlined-link link clear-all-link">Clear all</a> or select different options.</h2></div>',
                        );
                    }
                }

                if ($('.main-filter[data-tag="lens_polarized"]').hasClass('is-selected')) {
                    $('body').addClass('polarized-filter-selected');
                } else {
                    $('body').removeClass('polarized-filter-selected');
                }

                if ($('.main-filter.is-selected').length) {
                    //$('body').addClass('plp--hide-brand-blocks');
                } else {
                    $('body').removeClass('plp--hide-brand-blocks');
                }

                $('.filtered-loading').css('display', 'none');
                $('.collection-filter-groups-inner').removeClass('filtered-products-loading');
                if (newItemCount) {
                    if ($('body').hasClass('gift-collection')) {
                        $('.filter-groups-header .filtered--count').text(
                            newItemCount + ' Gifts',
                        );
                    } else {
                        $('.filter-groups-header .filtered--count').text(
                            newItemCount + ' Frames',
                        );
                    }
                } else {
                    newItemCount = 0;
                    if ($('body').hasClass('gift-collection')) {
                        $('.filter-groups-header .filtered--count').text('0 Gifts');
                    } else {
                        $('.filter-groups-header .filtered--count').text('0 Frames');
                    }
                }
                $('.collection-grid__products').attr('data-products-count', newItemCount);

                setTimeout(function () {
                    if (newItemCount < 6) {
                        if (newItemCount == 0) {
                            $('.get-more-products').addClass('hidden-get-more');
                        } else {
                            $('.pe--load-next-collection-wrapper').addClass(
                                'disable-collection-load',
                            );
                            $('.pe--load-more.pe--show-button').css('display', 'none');
                            if (
                                filteredCollectionURL != '/collections/pre-shop' &&
                                filteredCollectionURL != '/collections/sale'
                            ) {
                                $('.get-more-products').removeClass('hidden-get-more');
                            }
                            //  console.log('Less than 6 products');
                            setTimeout(function () {
                                checkNumberOfAdditionalProducts();
                            }, 100);
                            $('html, body').scrollTop(0);
                        }
                    } else {
                        // console.log('More than 6 products. Number of products: ' + newItemCount);
                        $('.pe--load-next-collection-wrapper').removeClass(
                            'disable-collection-load',
                        );
                        $('.pe--load-more.pe--show-button').css('display', 'block');
                        $('.get-more-products').addClass('hidden-get-more');
                    }
                }, 300);

                paginationIsLoading = !1;

                ajaxLoadElements();
                if ($('.mark-your-calendar-brand-block').length) {
                    attachMarkYourCalendarEvents();
                }

                superBrandBlockCarousels();

                
                setTimeout(function () {
                    if ($('.collection-grid__products').attr('data-products-count') > 48) {
                        $('.pagination').remove();
                        newPagination.insertAfter('#load-more-dump');
                        //  console.log('More than 49 products');
                        $('body').removeClass('collection-last-page-loaded');
                        $('.pe--load-more').removeClass('pe--show-button');
                        $('.spinner-gif').show();
                    }

                    if ($('.collection-grid__products').attr('data-products-count') < 49) {
                        $('.pagination').remove();
                        //console.log('Less than 50');
                        $('body').addClass('collection-last-page-loaded');
                        $('.pe--load-more').removeClass('pe--show-button');
                    }

                    if ($('.main-filter.is-selected').length) {
                        $('.collection-refinement').addClass('filter-is-selected');
                    } else {
                        $('.collection-refinement').addClass('filter-is-selected');
                    }

                    checkFiltersAndSortSelection();

                    $('body').removeClass('plp--hide-brand-blocks');

                    $('main .brand-block-half').each(function (i) {
                        $(this).addClass('brand-block-half-' + (i + 1));
                    });

                    addInitialNumbersClasses();

                    if (!$('body').hasClass('grouped-collection-area')) {
                        if (deviceIsMobile.matches) {
                            reorderBrandBlocksPage1();
                        }
                    }
                }, 500);

                //loadReviews();

                
                
                history.pushState(
                    {
                        page: newUrl,
                    },
                    null,
                    newUrl,
                );

                initializeGTMTracking(productsContainer[0]);
                $('.collection-container').removeClass('ajax-loading');
                //fetchReviews(newUrlRequest);

                window.initializeTickers();
            }, 500);
        },
    });

    if (typeof mixpanel !== "undefined") {
        mixpanelFilterApplied(filterText, headingText);
    }
});

$(document).on('click', '.filter-clear-all, .clear-all-link', function (e) {
    e.preventDefault();
    var mainURL = originalCollectionURL;
    if ($('.holiday-filter-nav').length) {
        mainURL = $('.is-selected').attr('data-tag');
    }
    $('.filtered--count').text('');
    $('.filtered-loading').css('display', 'block');
    if ($(window).width() > 834) {
        scrollToTopFilterDesktop();
    } else {
        scrollToTop();
    }

    $('.filter-toggle em').text('');

    $('.collection-filter-groups-inner').addClass('filtered-products-loading');

    $('.Linklist__Item').removeClass('is-selected');

    $('body').removeClass('polarized-filter-selected');

    $('.collection-container').addClass('ajax-loading');
    $('.collection-filter-groups-inner').addClass('filtered-products-loading');

    //$('body').addClass('plp--hide-brand-blocks');

    $.get({
        url: mainURL + '?view=' + filtering_template_name,
        success: function (data) {
            // console.log('Got all products!');
            $('.filters-bar').addClass('show-filters-bar');
            setTimeout(function () {
                var newProductsWrapper = $(data).find('#product-grid');
                var newPagination = $(data).find('.pagination');
                var newPaginationHtml = newPagination.html();
                var newProductsHtml = newProductsWrapper.html();
                var newItemCount = newProductsWrapper.attr('data-products-count');
                $('main #product-grid').html(newProductsHtml);
                $('.collection-filter-groups').attr(
                    'data-collection-url',
                    originalCollectionURL,
                );
                var newItemCount = newProductsWrapper.attr('data-products-count');
                $('.filtered-loading').css('display', 'none');
                $('.collection-filter-groups-inner').removeClass('filtered-products-loading');
                if (newItemCount) {
                    if ($('body').hasClass('gift-collection')) {
                        $('.filter-groups-header .filtered--count').text(
                            newItemCount + ' Gifts',
                        );
                    } else {
                        $('.filter-groups-header .filtered--count').text(
                            newItemCount + ' Frames',
                        );
                    }
                } else {
                    if ($('body').hasClass('gift-collection')) {
                        $('.filter-groups-header .filtered--count').text('0 Gifts');
                    } else {
                        $('.filter-groups-header .filtered--count').text('0 Frames');
                    }
                }
                $('.collection-grid__products').attr('data-products-count', newItemCount);

                $('.filters-bar').removeClass('show-filters-bar');

                $('body').removeClass('plp--hide-brand-blocks');

                $('.sort-option').removeClass('is-selected');

                // console.log('filter product count' + newItemCount);
                setTimeout(function () {
                    if (newItemCount) {
                        if (newItemCount < 6) {
                            $('.pe--load-next-collection-wrapper').addClass(
                                'disable-collection-load',
                            );
                            $('.pe--load-more.pe--show-button').css('display', 'none');
                            $('.get-more-products').removeClass('hidden-get-more');
                        } else {
                            $('.pe--load-next-collection-wrapper').removeClass(
                                'disable-collection-load',
                            );
                            $('.pe--load-more.pe--show-button').css('display', 'block');
                            $('.get-more-products').addClass('hidden-get-more');
                        }
                    } else {
                        $('.pe--load-more').css('display', 'none');
                    }

                    if ($('.main-filter.is-selected').length) {
                        $('.collection-refinement').addClass('filter-is-selected');
                    } else {
                        $('.collection-refinement').addClass('filter-is-selected');
                    }
                }, 300);

                paginationIsLoading = !1;
                ajaxLoadElements();

                superBrandBlockCarousels();

                addInitialNumbersClasses();

                if (deviceIsMobile.matches) {
                    reorderBrandBlocksPage1();
                }

                if ($('.mark-your-calendar-brand-block').length) {
                    attachMarkYourCalendarEvents();
                }
                setTimeout(function () {
                    if ($('.collection-grid__products').attr('data-products-count') > 48) {
                        $('.pagination').remove();
                        newPagination.insertAfter('#load-more-dump');

                        //  console.log('More than 24 products');
                        $('body').removeClass('collection-last-page-loaded');
                        $('.pe--load-more').removeClass('pe--show-button');
                        $('.spinner-gif').show();
                    }

                    if ($('.collection-grid__products').attr('data-products-count') < 49) {
                        $('.pagination').remove();
                        // console.log('Less than 24');
                        $('body').addClass('collection-last-page-loaded');
                        $('.pe--load-more').addClass('pe--show-button');
                    }

                    if ($('.main-filter.is-selected').length) {
                        $('.collection-refinement').addClass('filter-is-selected');
                    } else {
                        $('.collection-refinement').addClass('filter-is-selected');
                    }

                    $('body').removeClass('plp--hide-brand-blocks');
                }, 500);

                //loadReviews();

                

                $('main .brand-block-half').each(function (i) {
                    $(this).addClass('brand-block-half-' + (i + 1));
                });

                history.pushState(
                    {
                        page: mainURL,
                    },
                    null,
                    mainURL,
                );
                $('.collection-container').removeClass('ajax-loading');
                $('.hide-product-counter').removeClass('hide-product-counter');

                initializeGTMTracking(productsContainer[0]);

                window.dispatchEvent(new CustomEvent('feraWidgetsLoaded'));

                window.initializeTickers();

                // fetchReviews(mainURL);
            }, 500);
        },
    });

    if (typeof mixpanel !== "undefined") {
        mixpanelClearFilter();
    }

});

$(document).on('click', '.sort-option', function () {
    var $this = $(this);
    var value = $this.attr('data-value');
    var currentSort = getSortByValue();
    var sortOptionText = $(this).text().trim();

    // Display loading indicators
    $('.filtered--count').text('');
    $('.filtered-loading').css('display', 'block');

    if ($(window).width() > 834 && $(window).scrollTop() != 0) {
        scrollToTopFilterDesktop();
    }

    if ($(window).width() < 834) {
        scrollToTop();
    }

    

    function updateSortingUrl(sortValue, includeView = true) {
        let baseUrl = window.location.pathname;
            
        let currentUrl = new URL(baseUrl, window.location.origin);

        // Keep existing query parameters except sort_by
        window.location.search.slice(1).split('&').forEach(param => {
            if (param && !param.startsWith('sort_by=') && !param.startsWith('view=')) {
                const [key, value] = param.split('=');
                currentUrl.searchParams.set(key, value);
            }
        });
        
        // If clicking an already selected sort option, leave sort_by off
        if (value === currentSort) {
            $('.sort-option').removeClass('is-selected');
            $('.sort-option').parents('li').removeClass('is-selected');
            $('body').attr('data-sort-by', 'manual');
        } else {
            // Otherwise, set the new sort parameter
            currentUrl.searchParams.set('sort_by', sortValue);
            $('.sort-option').removeClass('is-selected');
            $this.addClass('is-selected');
            $this.parents('li').addClass('is-selected').siblings().removeClass('is-selected');
        }

        if (includeView) {
            currentUrl.searchParams.set('view', filtering_template_name);
        }

        return currentUrl.href;
    }

    var newSorting = updateSortingUrl(value, true); // URL for AJAX, includes the view parameter
    var newUrlWithoutView = updateSortingUrl(value, false);

    // Add loading class
    $('.collection-filter-groups-inner').addClass('filtered-products-loading');

    $.get({
        url: newSorting,
        success: function (data) {
            $('.filters-bar').addClass('show-filters-bar');
            var newProductsWrapper = $(data).find('#product-grid');
            var newPagination = $(data).find('.pagination');
            var newPaginationHtml = newPagination.html();
            var newProductsHtml = newProductsWrapper.html();
            var newItemCount = newProductsWrapper.attr('data-products-count');
            $('body').attr('data-sort-by', value);
            $('main #product-grid').html(newProductsHtml);

            

            var newItemCount = newProductsWrapper.attr('data-products-count');
            if ($('body').hasClass('gift-collection')) {
                $('.filter-groups-header .filtered--count').text(newItemCount + ' Gifts');
            } else {
                $('.filter-groups-header .filtered--count').text(newItemCount + ' Frames');
            }
            $('.filtered-loading').css('display', 'none');
            $('.collection-filter-groups-inner').removeClass('filtered-products-loading');

            $('.collection-grid__products').attr('data-products-count', newItemCount);

            // Update browser history with the clean URL (without view parameter)
            history.pushState(
                {
                    page: newUrlWithoutView,
                },
                null,
                newUrlWithoutView,
            );

            paginationIsLoading = !1;
            ajaxLoadElements();

            $('.pagination').html(newPaginationHtml);

            if ($('.mark-your-calendar-brand-block').length) {
                attachMarkYourCalendarEvents();
            }

            // Track the sort event in mixpanel if available
            if (typeof mixpanel !== "undefined") {
                mixpanelSortCompleted(sortOptionText);
            }

            window.dispatchEvent(new CustomEvent('feraWidgetsLoaded'));

            window.initializeTickers();
        },
    });
});

$(document).ready(function () {
    var getSortUrlParameter = function getSortUrlParameter(sortParam) {
        var sortPageURL = window.location.search.substring(1),
            sortURLVariables = sortPageURL.split('&'),
            sortParameterName,
            i;

        for (i = 0; i < sortURLVariables.length; i++) {
            sortParameterName = sortURLVariables[i].split('=');

            if (sortParameterName[0] === sortParam) {
                return typeof sortParameterName[1] === undefined
                    ? true
                    : decodeURIComponent(sortParameterName[1]);
            }
        }
        return false;
    };

    var sortBy = getSortUrlParameter('sort_by');

    $('.sort-option[data-value="' + sortBy + '"]')
        .parents('li')
        .addClass('is-selected');
    $('.sort-option[data-value="' + sortBy + '"]').addClass('is-selected');

    $(document).on('click', '.filters-overlay', function () {
        var $this = $(this);
        if (!$('body').hasClass('gift-collection')) {
            if ($this.parents('.collection-refinement').hasClass('showing-filters')) {
                $this
                    .parents('.collection-refinement')
                    .find('.filters-toggle-icon span')
                    .text('FILTER');

                if ($(window).width() > 990) {
                    $this
                        .parents('.collection-refinement')
                        .find('.filters-toggle-icon span')
                        .html(
                            `<img src="${filterIcon}" role="presentation" alt="Filters">`,
                        );
                } else {
                    $this
                        .parents('.collection-refinement')
                        .find('.filters-toggle-icon span')
                        .text('FILTER');
                }
            } else {
                $this
                    .parents('.collection-refinement')
                    .find('.filters-toggle-icon span')
                    .text('CLOSE');
            }
        }

        if (!$('.collection-refinement').hasClass('filter-is-selected')) {
            $('.filters-bar').toggleClass('show-filters-bar');
        }

        $('.collection-filter-groups').toggleClass('show-filters');
        $('.collection-refinement').toggleClass('showing-filters');

        $('body').toggleClass('collection-filters-showing');
    });
});

$(document).ready(function () {
    var getSortUrlParameter = function getSortUrlParameter(sortParam) {
        var sortPageURL = window.location.search.substring(1),
            sortURLVariables = sortPageURL.split('&'),
            sortParameterName,
            i;

        for (i = 0; i < sortURLVariables.length; i++) {
            sortParameterName = sortURLVariables[i].split('=');

            if (sortParameterName[0] === sortParam) {
                return typeof sortParameterName[1] === undefined
                    ? true
                    : decodeURIComponent(sortParameterName[1]);
            }
        }
        return false;
    };

    var sortBy = getSortUrlParameter('sort_by');

    $('.sort-option[data-value="' + sortBy + '"]')
        .parents('li')
        .addClass('is-selected');
    $('.sort-option[data-value="' + sortBy + '"]').addClass('is-selected');

    $(document).on('click', '.filters-overlay', function () {
        var $this = $(this);
        if (!$('body').hasClass('gift-collection')) {
            if ($this.parents('.collection-refinement').hasClass('showing-filters')) {
                $this
                    .parents('.collection-refinement')
                    .find('.filters-toggle-icon span')
                    .text('FILTER');

                if ($(window).width() > 990) {
                    $this
                        .parents('.collection-refinement')
                        .find('.filters-toggle-icon span')
                        .html(
                            `<img src="${filterIcon}" role="presentation" alt="Filters">`,
                        );
                } else {
                    $this
                        .parents('.collection-refinement')
                        .find('.filters-toggle-icon span')
                        .text('FILTER');
                }
            } else {
                $this
                    .parents('.collection-refinement')
                    .find('.filters-toggle-icon span')
                    .text('CLOSE');
            }
        }

        if (!$('.collection-refinement').hasClass('filter-is-selected')) {
            $('.filters-bar').toggleClass('show-filters-bar');
        }

        $('.collection-filter-groups').toggleClass('show-filters');
        $('.collection-refinement').toggleClass('showing-filters');

        $('body').toggleClass('collection-filters-showing');
    });
});

$(document).on('click', '.view-size-toggle', function () {
    $('body').toggleClass('large-product-view');
});

$(document).on('click', '.get-more-products', function () {
    var $this = $(this);

    $this.text('Loading...');

    function getLastPartOfUrl(url) {
        const urlParts = url.split('/');
        return urlParts[urlParts.length - 1];
    }

    const currentUrlPath = window.location.pathname;
    const lastPart = getLastPartOfUrl(currentUrlPath);

    var seeMoreCollectionHandle = $this.attr('data-collection-handle-to-get');

    var existingProductHandles = [];
    $('#load-more-dump #product-grid li[data-product-handle]').each(function () {
        existingProductHandles.push($(this).data('product-handle'));
    });

    let get_more_request_url =
        '/collections/' +
        seeMoreCollectionHandle +
        '/' +
        lastPart +
        '?view=' +
        filtering_template_name;
    let view_url = '/collections/' + seeMoreCollectionHandle + '/' + lastPart;

    $.get({
        url: get_more_request_url,
        success: function (data) {
            $('.collection-filter-groups').attr(
                'data-collection-url',
                '/collections/all-styles',
            );

            setTimeout(function () {
                var newCounter = $(data).find('#product-grid').attr('data-products-count');
                if ($('body').hasClass('gift-collection')) {
                    $('.filtered--count').text(newCounter + ' Gifts');
                } else {
                    $('.filtered--count').text(newCounter + ' Frames');
                }

                var newProductsWrapper = $(data).find('#product-grid');

                newProductsWrapper.find('li[data-product-handle]').each(function () {
                    var productHandle = $(this).data('product-handle');

                    if ($.inArray(productHandle, existingProductHandles) === -1) {
                        $('#load-more-dump #product-grid').append($(this));
                        existingProductHandles.push(productHandle);
                    }
                });

                paginationIsLoading = !1;
                ajaxLoadElements();
                $('.collection-container').removeClass('ajax-loading');
                $('.get-more-products').addClass('hidden-get-more');
                $('.pe--load-next-collection-wrapper').removeClass('disable-collection-load');
            }, 100);

            history.pushState(
                {
                    page: view_url,
                },
                null,
                view_url,
            );

            // fetchReviews(view_url);
        },
        error: function (jqXHR, textStatus, errorThrown) {
            console.log('AJAX Error: ' + textStatus + ' ' + errorThrown);
            console.log('AJAX Status: ' + jqXHR.status);
            console.log('AJAX Response: ' + jqXHR.responseText);
        },
    });
});

const holidayClasses = {
    collectionSidebar: '.holiday-sidebar',
    holidayHeading: '.holiday-filter-group:not(.sort-group)',
    accordionContent: '.accordion-content',
    holidayFilterItem: '.holiday-Linklist__Item:not(.sort-item):not(.nav-scroll-trigger)',
    sortItem: '.holiday-Linklist__Item.sort-item',
    filter: '.Linklist:not(.sort-list)',
};

// Accordion
const holidayHeading = $(holidayClasses.holidayHeading);

var destroyButton = document.getElementById('destroy');
document.addEventListener('DOMContentLoaded', function () {
    ajaxLoadElements();
});

holidayHeading.on('click', function () {
    const parentItem = $(this).parent();
    const content = parentItem.find(holidayClasses.accordionContent).first();

    $(this).toggleClass('open');
    content.slideToggle();
});

// Tag filter
const holidayURL = window.location.origin + window.location.pathname;
const holidayFilterItem = $(holidayClasses.holidayFilterItem);
let holidayCollectionURL = $(holidayClasses.collectionSidebar).data('collection-url');

holidayFilterItem.each(function () {
    const tag = $(this).data('tag');
});

$(document).ready(function () {
    if ($('body').hasClass('template-gift-finder')) {
        function throwConfetti(e) {
            // Burst of celebratory confetti!
            window.throwConfetti(document.getElementById('nav-confetti'), {
                angle: 90,
                spread: 15,
                startVelocity: 500,
                elementCount: 120,
                decay: 0.1,
            });
        }
        throwConfetti();
    }
});

function getSortByValue() {
    const params = new URLSearchParams(window.location.search);
    return params.get('sort_by') || false; // Returns null if "sort_by" doesn't exist, so we use || to return false instead
}

$(document).on('click', '.holiday-standard-link', function () {
    $('.is-selected').removeClass('is-selected');
    $(this).addClass('is-selected');
});

function getLocalLaunchTimeBrandBlock() {
    const targetDate = new Date('2025-03-04T10:00:00-05:00'); // 10am EST
    
    // Get the time in user's local timezone
    const localTime = targetDate.toLocaleTimeString('en-US', {
      hour: 'numeric', // Only show hour
      hour12: true     // Use 12-hour format (AM/PM)
    });
    
    // Remove any spaces and convert to lowercase
    const shortTime = localTime.replace(/\s/g, '').toLowerCase();
    
    // Get timezone abbreviation
    const timezoneOffset = targetDate.getTimezoneOffset();
    let timezoneAbbr = '';
    
    // Convert timezone offset to hours (negative because getTimezoneOffset returns opposite sign)
    const offsetHours = -timezoneOffset / 60;
    
    // Determine timezone abbreviation based on offset
    if (offsetHours === -5) {
      timezoneAbbr = 'ET'; // Eastern Time
    } else if (offsetHours === -6) {
      timezoneAbbr = 'CT'; // Central Time
    } else if (offsetHours === -8) {
      timezoneAbbr = 'PST'; // Pacific Time
    } else {
      // For other timezones, use the browser's timezone abbreviation
      const options = { timeZoneName: 'short' };
      const timeZoneString = new Intl.DateTimeFormat('en-US', options).format(targetDate);
      timezoneAbbr = timeZoneString.split(' ').pop();
    }
    
    return shortTime + ' ' + timezoneAbbr;
  }
  


holidayFilterItem.on('click', function () {
    let search = window.location.search;

    var $clickedNavButton = $(this).find('button');
    var clickedNavLabel = $.trim($clickedNavButton.attr('data-value') || $clickedNavButton.text());
    var $currentCollectionBreadcrumb = $('.js-current-collection-breadcrumb');
    if ($currentCollectionBreadcrumb.length && clickedNavLabel) {
        $currentCollectionBreadcrumb.text(clickedNavLabel);
    }

    function throwConfetti(e) {
        // Burst of celebratory confetti!
        window.throwConfetti(document.getElementById('nav-confetti'), {
            angle: 90,
            spread: 20,
            startVelocity: 70,
            elementCount: 90,
            decay: 0.7,
        });
    }

    if ($('body').hasClass('sale-area') || $('body').hasClass('template-name-collection')) {
        var link_title = $(this).find('button').attr('data-value');

        if (link_title === 'SALE') {
            link_title = 'ALL SALE';
        }

        if (link_title === 'ALL GIFTS') {
            link_title = 'GIFT GUIDE';
            //console.log(document.getElementById('nav-confetti'))
        }

       

        if (link_title === 'SALE') {
            link_title = 'ALL SALE';
        }

        
    }

    $('.featured-collection-filter-wrapper').removeClass('featured-collection-filter-ready');
    $('.fake-select-open').removeClass('fake-select-open');

    function getSortByValue() {
        const params = new URLSearchParams(window.location.search);
        return params.get('sort_by') || false; // Returns null if "sort_by" doesn't exist
    }

    // Utility function to create a request URL and a clean URL for history.pushState
    function createUrls(basePath) {
        const currentSort = getSortByValue();
        const baseUrl = window.location.origin;
        let fullUrl = new URL(basePath, baseUrl);
        let cleanUrl = new URL(basePath, baseUrl); // This will be used for history.pushState

        // Add "sort_by" to both URLs if it exists
        if (currentSort) {
            fullUrl.searchParams.set('sort_by', currentSort);
            cleanUrl.searchParams.set('sort_by', currentSort);
        }

        // Add "view" parameter only to the full URL used for the AJAX request
        if (typeof filtering_template_name !== 'undefined') {
            fullUrl.searchParams.set('view', filtering_template_name);
        }

        // Return both URLs
        return {
            requestEndpoint: fullUrl.toString(),
            cleanUrl: cleanUrl.toString(),
        };
    }

    // Example usage
    var $this = $(this);
    let newholidayCollectionURL = $this.attr('data-tag');
    $('.collection-filter-groups').attr('data-collection-url', newholidayCollectionURL);

    // Generate both URLs
    let urls = createUrls(newholidayCollectionURL);

    //console.log('Request URL:', urls.requestEndpoint);
    //console.log('Clean URL for history:', urls.cleanUrl);
    $('.filtered--count').text('');
    $('.filtered-loading').css('display', 'block');

    const filter = $(this).parents('[data-filter]');
    // console.log('*** filter', filter)
    var addActiveClass = true;
     if ($(this).hasClass('active')) {
         addActiveClass = false
     }

    // const holidayFilterItems = document.querySelectorAll('.holiday-Linklist__Item');
    // holidayFilterItems.removeClass('active');
    // if (addActiveClass) {
    //     $(this).addClass('active');
    // }

    if (link_title === 'GIFT GUIDE' && $(this).hasClass('is-selected')) {
        scrollToTop();
    } else {
        if (link_title === 'GIFT GUIDE' && !$(this).hasClass('is-selected')) {
            setTimeout(function () {
                throwConfetti();
            }, 300);
        }
        $(this).toggleClass('is-selected').siblings().removeClass('is-selected');
    }

    var activeItems = $('.holiday-nav-filters').find(
        holidayClasses.holidayFilterItem + '.is-selected',
    );
    var activeTags = [];

    activeItems.each(function (index, el) {
        var tag = $(el).attr('data-tag');

        if (tag) {
            activeTags.push(tag);
        }
    });

    var tagsUrl = activeTags.join('+');

    var newUrl = holidayCollectionURL;

    newUrl += search;

    $('.collection-container').addClass('ajax-loading');

    $('.holiday-nav-filters-inner').addClass('filtered-products-loading');
    var $this = $(this);

    scrollToTop();
    //console.log('scrolled to top');

    var nameValue = $this.attr('data-gtm-label');
    //console.log('Value: ' + nameValue);

    var giftFinderCurrentURL = $('.holiday-main-filter.is-selected').attr(
        'data-collection-handle',
    );

    if (link_title === 'GIFT GUIDE' || link_title === 'MOST GIFTED') {
        newholidayCollectionURL = constructFilterUrl(giftFinderCurrentURL);
    }

    var isGroupedCollection = false;

    //console.log('Nav click endpoint: ' + urls.requestEndpoint);

    $.get({
        url: urls.requestEndpoint,
        success: function (data) {
            //console.log('Success');
            setTimeout(function () {

                var newItemCount;
                var GIFT_GUIDE_COLLECTION_TITLES = [
                    'GIFT GUIDE',
                    'ALL GIFTS',
                    'FOR HIM',
                    'FOR HER',
                    'FOR THE IMPOSSIBLE',
                    'FOR THE TRENDSETTER',
                    'MOST GIFTABLE',
                    'UNDER $300',
                    'THE PARTY EDIT'
                ];

                if (GIFT_GUIDE_COLLECTION_TITLES.includes(link_title)) {
                    $('body').addClass('template-gift-finder');
                    setTimeout(function () {
                        $('.featured-collection-filter-wrapper').addClass(
                            'featured-collection-filter-ready',
                        );
                    }, 1000);
                } else {
                    $('body').removeClass('template-gift-finder');
                    $('.featured-collection-filter-wrapper').removeClass(
                        'featured-collection-filter-ready',
                    );
                }

                if (link_title == "BEST SELLERS") {
                    $('body').addClass('best-sellers-sale-collection');
                    $('.filters-toggle-btn').attr('aria-hidden', 'true');
                    $('.filters-toggle-btn').attr('tabindex', '-1');
                } else {
                    $('body').removeClass('best-sellers-sale-collection');
                    $('.filters-toggle-btn').attr('aria-hidden', 'false');
                    $('.filters-toggle-btn').attr('tabindex', '0');
                }

                if (link_title === 'BEST OF 2023') {
                    $('body').addClass('grouped-collection-area');

                    var newProductsWrapper = $(data).find('#ProductGridContainer');
                    var newPagination = $(data).find('.pagination');
                    var newPaginationHtml = newPagination.html();
                    var newProductsHtml = newProductsWrapper.html();
                    var $currentFilters = $('.collection-filter-groups-inner');
                    var newFilters = $(data).find('.collection-filter-groups-inner').html();
                    newItemCount = newProductsWrapper.attr('data-products-count');
                    productsContainerParent.html(newProductsHtml);
                    //console.log('is best of 2023');
                    $('.pagination').remove();
                } else if (
                    $('body').hasClass('grouped-collection-area') &&
                    link_title != 'BEST OF 2023'
                ) {
                    var newProductsWrapper = $(data).find('#product-grid');
                    var newPagination = $(data).find('.pagination');
                    var newPaginationHtml = newPagination.html();
                    var newProductsHtml = newProductsWrapper.html();
                    var $currentFilters = $('.collection-filter-groups-inner');
                    var newFilters = $(data).find('.collection-filter-groups-inner').html();
                    newItemCount = newProductsWrapper.attr('data-products-count');
                    productsContainerParent.html(newProductsWrapper);
                    $('body').removeClass('grouped-collection-area');
                    //console.log('is NOT best of 2023 and was originally on 2023');
                } else {
                    $('body').removeClass('grouped-collection-area');
                    var newProductsWrapper = $(data).find('#product-grid');
                    var newPagination = $(data).find('.pagination');
                    var newPaginationHtml = newPagination.html();
                    var newProductsHtml = newProductsWrapper.html();
                    var $currentFilters = $('.collection-filter-groups-inner');
                    var newFilters = $(data).find('.collection-filter-groups-inner').html();
                    newItemCount = newProductsWrapper.attr('data-products-count');
                    productsContainer.html(newProductsHtml);

                    if ($('body').hasClass('template-gift-finder')) {
                        if (link_title === 'GIFT GUIDE') {
                            console.log('Gift guide');
                            //$('.holiday-main-filter.all-gifts .gift-count').text(newItemCount);
                            console.log('Products count: ' + newItemCount);
                        } else if (link_title === 'MOST GIFTED') {
                            console.log('MOST GIFTED');
                            console.log('Products count: ' + newItemCount);
                            //$('.holiday-main-filter.most-gifted .gift-count').text(newItemCount)
                        }
                    }

                    //console.log('is NOT best of 2023')
                }

                $currentFilters.html(newFilters);
                if (link_title != 'GIFT GUIDE') {
                    $('body').removeClass('plp--hide-brand-blocks');
                } else {
                    if (link_title === 'GIFT GUIDE' && $('.manually-filtered-dropdown').length) {
                        $('body').removeClass('plp--hide-brand-blocks');
                    }
                }


                superBrandBlockCarousels();

                $('main .brand-block-half').each(function (i) {
                    $(this).addClass('brand-block-half-' + (i + 1));
                });

                if ($(window).width() < 991) {
                    $('.card-brand-block:not(.last-product-brand-block)').each(function (i) {
                        $(this).addClass('editorial--block-' + (i + 1));
                    });

                    $('main .plp-product-standard:not(.brand-block-grid-collection-product)').each(function (i) {
                        $(this).addClass('product--block-' + (i + 1));
                    });
                    setTimeout(function () {
                        if (
                            $('main .plp-product-standard').length == 5 &&
                            $(window).width() < 991 &&
                            $('body').hasClass('template-gift-finder')
                        ) {
                            $('.card-brand-block').insertAfter('main .product--block-5');
                        }
                    }, 100);

                    

                    addInitialNumbersClasses();

                    if (!$('body').hasClass('grouped-collection-area')) {
                        if (deviceIsMobile.matches) {
                            reorderBrandBlocksPage1();
                        }
                    }
                }

                if (!$('body').hasClass('grouped-collection-area')) {
                    $('.grouped-collection-area .brand-block-carousel').slick('unslick');
                } else {
                    $('.grouped-collection-area .brand-block-carousel').slick({
                        dots: true,
                        autoplay: true,
                        pauseOnHover: false,
                        fade: true,
                        infinite: true,
                        arrows: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        easing: 'ease',
                        vertical: false,
                        autoplaySpeed: 4000,
                    });
                }

                $('.filtered-loading').css('display', 'none');
                $('.holiday-nav-filters-inner').removeClass('filtered-products-loading');
                $('.holiday-filter-groups-header .filtered--count').text(
                    newItemCount + ' Items',
                );
                newProductsWrapper.attr('data-products-count', newItemCount);

                setTimeout(function () {
                    if (newProductsWrapper.attr('data-products-count') < 5) {
                        $('.pe--load-next-collection-wrapper').addClass(
                            'disable-collection-load',
                        );
                        $('.pe--load-more.pe--show-button').css('display', 'none');
                    } else {
                        $('.pe--load-next-collection-wrapper').removeClass(
                            'disable-collection-load',
                        );
                        $('.pe--load-more.pe--show-button').css('display', 'block');
                    }

                    if ($(window).width() < 835) {
                    }
                }, 300);

                paginationIsLoading = !1;

                if ($('.mark-your-calendar-brand-block').length) {
                    attachMarkYourCalendarEvents();
                }

                ajaxLoadElements();
                setTimeout(function () {
                    if (newProductsWrapper.attr('data-products-count') > 48) {
                        $('.pagination').remove();
                        newPagination.insertAfter('#load-more-dump');

                        //  console.log('More than 24 products');
                        $('body').removeClass('collection-last-page-loaded');
                        $('.pe--load-more').removeClass('pe--show-button');
                        $('.spinner-gif').show();

                        setTimeout(function () {
                            if ($('.pagination-style-scroll').length) {
                                $(window).on(
                                    'scroll',
                                    _.throttle(
                                        function () {
                                            var limit = 3 * $(window).height();
                                            if (
                                                $(document).height() - $(window).scrollTop() <
                                                limit
                                            ) {
                                                if (!paginationIsLoading) {
                                                    paginationIsLoading = !0;
                                                    $('.pagination-load-more').trigger('click');

                                                    //console.log('Loading');
                                                }
                                            }
                                        },
                                        250,
                                        {
                                            leading: !0,
                                            trailing: !0,
                                        },
                                    ),
                                );
                            }
                        }, 500);
                    }

                    if (newProductsWrapper.attr('data-products-count') < 50) {
                        $('.pagination').remove();
                        // console.log('Less than 24');
                        $('body').addClass('collection-last-page-loaded');
                        $('.pe--load-more').addClass('pe--show-button');
                    }

                    if (newProductsWrapper.attr('data-products-count') < 25) {
                        // console.log('Less than 24');
                        $('body').addClass('collection-last-page-loaded');
                        $('.pe--load-more').addClass('pe--show-button');
                    }
                }, 500);

                //loadReviews();

                initializeGTMTracking();

                history.pushState(
                    {
                        page: urls.cleanUrl,
                    },
                    null,
                    urls.cleanUrl,
                );

                // fetchReviews(newholidayCollectionURL);
                setTimeout(function () {
                    $('.collection-container').removeClass('ajax-loading');
                }, 300);

                document.querySelectorAll('.card-brand-block .event-launch-time').forEach(element => {
                    element.textContent = getLocalLaunchTimeBrandBlock();
                });

                window.initializeTickers();
                
                setTimeout(function() {
                    window.dispatchEvent(new CustomEvent('feraWidgetsLoaded'));
                },2000);
            }, 100);
        },
    });
});

document.addEventListener('DOMContentLoaded', function () {
    // Find the div with class "holiday-filter-nav"
    const holidayNav = document.querySelector('.holiday-filter-nav');

    // If the div is found, set the "--has-holiday-nav" CSS variable to true
    if (holidayNav) {
        document.documentElement.style.setProperty('--has-holiday-nav', 'true');
    }

});

if (
    $(window).width() < 835 &&
    ($('body').hasClass('template-ALL SALE-best-sellers') ||
        $('body').hasClass('template-ALL SALE-going-fast-sale'))
) {
    var offsetIsSelected = $('.is-selected').offset();

    $('.holiday-filter-contents ul').animate({
        scrollLeft: offsetIsSelected.left,
    });
}

// Move clicked LI to the first position in its UL for -sale-he-2025 pages
// Updates breadcrumb title based on top navigation link clicked (fitted for template-gift-finder)
$('.holiday-filter-contents ul li button').on('click', function () {
    var $li = $(this);
    var trimmedHtml = $.trim($li.html());

    // Only run on desktop and specific sale pages
    if (
        $('body').attr('class') &&
        $('body').attr('class').indexOf('template-gift-finder') !== -1
        // $('body').attr('class').indexOf('-sale-he-2025') !== -1
    ) {
        var $parentBreadcrumb = $('.breadcrumb-item.main-breadcrumb');
        if ($parentBreadcrumb.length) {
            $parentBreadcrumb.html(trimmedHtml);
        }

    }
});



document.addEventListener('DOMContentLoaded', () => {
    
    // Is this a collection page? If so, log the collection handle
    const path = window.location.pathname;
    let isCollectionPage = false;
    let handle = false;
    if (path.includes('/collections/')) {
        let parts = path.split('/collections/');
        handle = parts[1].split('/')[0];
        isCollectionPage = true;
        // console.log("*** Collection Handle:", handle);
    } 

    if(isCollectionPage) {
        let $navBarLinks = $('.holiday-filter-contents ul li button');
        $navBarLinks.on('click', function () {
            // console.log('*** Holiday filter click - moving LI to top and updating breadcrumb');
            var $li = $(this);
            var trimmedHtml = $.trim($li.html());
            // console.log('*** trimmedHtml', trimmedHtml);
            // Only run on desktop and specific sale pages
            var $parentBreadcrumb = $('.breadcrumb-item.main-breadcrumb');
            // console.log('*** parentBreadcrumb', $parentBreadcrumb);
            if ($parentBreadcrumb.length) {
                $parentBreadcrumb.html(trimmedHtml);
                // console.log('*** parentBreadcrumb, updated', $parentBreadcrumb);
            }
        });
    }


    setTimeout(function () {
        $('main .plp-product-standard:first-child').addClass('nudge-image');
    }, 500);
    setTimeout(function () {
        $('main .plp-product-standard:first-child').removeClass('nudge-image');
    }, 1000);

    if (
        ($('body').hasClass('sale-area') && !$('body').hasClass('template-product')) ||
        ($('body').hasClass('special-collection') && !$('body').hasClass('template-product'))
    ) {
        setTimeout(function () {
            $('.holiday-filter-nav').addClass('nudge-nav');
        }, 3000);
        setTimeout(function () {
            $('.holiday-filter-nav').removeClass('nudge-nav');
        }, 4000);
    }
});

$(document).ready(function () {
    if ($(window).width() > 990) {
        $('.filter-toggle').each(function () {
            var $this = $(this);
            $this.attr('aria-expanded', true);
            $this.attr('tabindex', '-1');
        });
    }
});

function giftFinderPLPElements(data, newUrl) {
    $('body').addClass('plp--hide-brand-blocks');
    $('.filters-bar').removeClass('show-filters-bar');
    var newProductsWrapper = $(data).find('#product-grid');
    var newItemCount = newProductsWrapper.attr('data-products-count');

    var firstTenProducts = newProductsWrapper.find('.plp-product-grid-item');
    $('.collection-grid__products').attr('data-products-count', newItemCount);

    if ($('.holiday-main-filter.all-gifts').hasClass('is-selected')) {
        //console.log('Gift guide');
        $('.holiday-main-filter.all-gifts .gift-count').text(newItemCount);
        //console.log('Products count: ' + newItemCount);
    } else if ($('.holiday-main-filter.most-gifted').hasClass('is-selected')) {
        //console.log('MOST GIFTED');
        //console.log('Products count: ' + newItemCount);
        $('.holiday-main-filter.most-gifted .gift-count').text(newItemCount);
    }

    //$('body').removeClass('plp--hide-brand-blocks');

    setTimeout(function () {
        $('main .plp-product-standard:not(.brand-block-grid-collection-product)').each(function (i) {
            $(this).addClass('product--block-' + (i + 1));
        });

        if ($('main .plp-product-standard').length == 5 && $(window).width() < 991) {
            $('.card-brand-block').insertAfter('main .product--block-5');
        }
    }, 100);

    if ($('.featured-collection-filter-wrapper .manually-filtered-dropdown').length == 0) {
        $('.holiday-main-filter.all-gifts, .holiday-main-filter.most-gifted').removeClass(
            'option-selected',
        );
    }

    $('body').removeClass('plp--hide-brand-blocks');

    var limitedProductsHtml = $('<div>').append(firstTenProducts).html();

    var newPagination = $(data).find('.pagination');
    var newPaginationHtml = newPagination.html();
    var newProductsHtml = newProductsWrapper.html();

    //console.log(newUrl);

    if (
        $(
            '.featured-collection-filter-wrapper .featured-collection-selected-filter[data-display-text=""]',
        ).length === 4
    ) {
        newItemCount = '';
    }

    if (limitedProductsHtml) {
        $('#load-more-dump #product-grid').html(firstTenProducts);
    } else {
        let emptyCollection = $(data).find('#emptyCollection');
        let emptyCollectionHTML = emptyCollection.html();
        //console.log('no products found');

        $('.pe--load-more').css('display', 'none');

        $('#ProductGridContainer #product-grid').empty();

        if (emptyCollectionHTML) {
            $('#ProductGridContainer #product-grid').append(emptyCollectionHTML);
        } else {
            // console.log('no products message found');
            $('#ProductGridContainer #product-grid').append(
                '<div class="title-wrapper center"><h2 class="title title--primary">Oops, you stumped us!<br><a href="{{ collection.url }}" class="underlined-link link clear-all-link">Clear all</a> or select different options.</h2></div>',
            );
        }
    }

    setTimeout(function () {
        $('body').removeClass('getting-gifts');
    }, 1500);

    if ($('.main-filter[data-tag="lens_polarized"]').hasClass('is-selected')) {
        $('body').addClass('polarized-filter-selected');
    } else {
        $('body').removeClass('polarized-filter-selected');
    }

    $('.filtered-loading').css('display', 'none');
    $('.collection-filter-groups-inner').removeClass('filtered-products-loading');
    if (newItemCount) {
        //console.log('Product count: ' + newItemCount);
        if ($('body').hasClass('template-gift-finder')) {
            if ($('.holiday-main-filter.all-gifts').hasClass('is-selected')) {
                //$('.holiday-main-filter.all-gifts .gift-count').text(newItemCount)
            } else if ($('holiday-main-filter.most-gifted').hasClass('is-selected')) {
                //$('.holiday-main-filter.most-gifted .gift-count').text(newItemCount)
            }
        }
    } else {
        newItemCount = 0;
        if ($('body').hasClass('gift-collection')) {
            $('.filter-groups-header .filtered--count').text('0 Gifts');
        } else {
            $('.filter-groups-header .filtered--count').text('0 Frames');
        }

        $('.gift-count').text('');
    }

    paginationIsLoading = !1;

    ajaxLoadElements();
    if ($('.mark-your-calendar-brand-block').length) {
        attachMarkYourCalendarEvents();
    }
    if (newProductsWrapper.attr('data-products-count') > 48) {
        $('.pagination').remove();
        newPagination.insertAfter('#load-more-dump');

        // console.log('More than 24 products');
        $('body').removeClass('collection-last-page-loaded');
        $('.pe--load-more').removeClass('pe--show-button');
        $('.spinner-gif').show();

        setTimeout(function () {
            if ($('.pagination-style-scroll').length) {
                $(window).on(
                    'scroll',
                    _.throttle(
                        function () {
                            var limit = 3 * $(window).height();
                            if ($(document).height() - $(window).scrollTop() < limit) {
                                if (!paginationIsLoading) {
                                    paginationIsLoading = !0;
                                    $('.pagination-load-more').trigger('click');

                                    // console.log('Loading');
                                }
                            }
                        },
                        250,
                        {
                            leading: !0,
                            trailing: !0,
                        },
                    ),
                );
            }
        }, 500);
    }

    if (newProductsWrapper.attr('data-products-count') < 50) {
        $('.pagination').remove();
        // console.log('Less than 24');
        $('body').addClass('collection-last-page-loaded');
        $('.pe--load-more').addClass('pe--show-button');
    }

    if (newProductsWrapper.attr('data-products-count') < 25) {
        //  console.log('Less than 24');
        $('body').addClass('collection-last-page-loaded');
        $('.pe--load-more').addClass('pe--show-button');
    }
    history.pushState(
        {
            page: newUrl,
        },
        null,
        newUrl,
    );
    $('.collection-container').removeClass('ajax-loading');
    //fetchReviews(newUrlRequest);
}

var refreshInterval;
// Function to construct the filter URL
function constructFilterUrlRaw(giftFinderCurrentURL) {
    // Get all selected filter values that have been manually set by the user
    var filters = $(
        '.featured-collection-filter-wrapper .featured-collection-filters .manually-filtered-dropdown',
    )
        .map(function () {
            return $(this).find('.featured-collection-selected-filter').attr('data-tag');
        })
        .get()
        .join('&');

    // If filters are selected, construct the URL with filters
    // Otherwise, return the default URL

    //console.log('Filtered this');
    return filters
        ? `/collections/${giftFinderCurrentURL}?${filters}&view=gift-finder-plp`
        : '/collections/' + giftFinderCurrentURL + '?view=gift-finder-plp';
}

function constructFilterUrl(giftFinderCurrentURL) {
    // Get all selected filter values that have been manually set by the user
    var filters = $(
        '.featured-collection-filter-wrapper .featured-collection-filters .manually-filtered-dropdown',
    )
        .map(function () {
            return $(this).find('.featured-collection-selected-filter').attr('data-tag');
        })
        .get()
        .join('&');

    // If filters are selected, construct the URL with filters
    // Otherwise, return the default URL
    return filters
        ? `/collections/${giftFinderCurrentURL}?${filters}`
        : '/collections/' + giftFinderCurrentURL;
}

//refreshInterval = setInterval(clickGO, 5000);

function getMostGiftableProductCount(filterCountEndpoint) {
    //console.log(filterCountEndpoint);
    $.get({
        url: filterCountEndpoint + '&view=gift-finder-filter-count',
        success: function (data) {
            $('.holiday-main-filter.most-gifted .gift-count').text(data);
           // console.log('MOST GIFTED count: ' + filterCountEndpoint);
        },
    });
}

function getAllGiftsProductCount(filterCountEndpoint) {
    //console.log(filterCountEndpoint);
    $.get({
        url: filterCountEndpoint + '&view=gift-finder-filter-count',
        success: function (data) {
            $('.holiday-main-filter.all-gifts .gift-count').text(data);

           // console.log('All gifts count: ' + data);
        },
    });
}

document.addEventListener('DOMContentLoaded', function () {
    if ($('.option-selected').length) {
        if ($('.holiday-main-filter.all-gifts').hasClass('is-selected')) {
            var allGiftsCountEndpoint = $('.holiday-main-filter.most-gifted').attr(
                'data-request-path',
            );
            $('.holiday-main-filter.most-gifted').addClass('option-selected');
            if (allGiftsCountEndpoint != false) {
                getMostGiftableProductCount(allGiftsCountEndpoint);
            }
        } else if ($('.holiday-main-filter.most-gifted').hasClass('is-selected')) {
            var allGiftsCountEndpoint = $('.holiday-main-filter.all-gifts').attr(
                'data-request-path',
            );
            $('.holiday-main-filter.all-gifts').addClass('option-selected');
            if (allGiftsCountEndpoint != false) {
                getAllGiftsProductCount(allGiftsCountEndpoint);
            }
        }
    }
});

// Function to refresh the featured products based on filters
function refreshTopTen() {
    var giftFinderCurrentURL = $('.holiday-main-filter.is-selected').attr(
        'data-collection-handle',
    );

    // Construct the filter URL and log it to the console
    var filterUrlRaw = constructFilterUrlRaw(giftFinderCurrentURL);
   // console.log('Filter URL Raw:', filterUrlRaw);

    var filterUrl = constructFilterUrl(giftFinderCurrentURL);
   // console.log('Filter URL:', filterUrl); // Log the filter URL for debugging

    //console.log('This fired');

    $('.featured-collection-filters select').each(function () {
        $(this).addClass('manually-filtered');
    });

    $('.holiday-main-filter.all-gifts').attr('data-tag', filterUrl);
    let allGiftsURL = $('.holiday-main-filter.all-gifts').attr('data-tag');
    let newGiftsURL = allGiftsURL.replace('most-popular-gifts', 'all-gifts');
    $('.holiday-main-filter.all-gifts').attr('data-tag', newGiftsURL);

    $('.holiday-main-filter.most-gifted').attr('data-tag', filterUrl);
    let mostGiftableURL = $('.holiday-main-filter.most-gifted').attr('data-tag');
    let newMostGiftableURL = mostGiftableURL.replace('all-gifts', 'most-popular-gifts');
    $('.holiday-main-filter.most-gifted').attr('data-tag', newMostGiftableURL);

    $('body').addClass('getting-gifts');

    // Fetch the filtered or default product contents
    fetch(filterUrlRaw, { method: 'GET' })
        .then((response) => response.text())
        .then((productContents) => {
            $('.holiday-main-filter.all-gifts, .holiday-main-filter.most-gifted').addClass(
                'option-selected',
            );

            if (filterUrl.includes('most-popular-gifts')) {
                var allGiftsCountEndpoint = filterUrl.replace('most-popular-gifts', 'all-gifts');
                //console.log('Updated URL: ' + allGiftsCountEndpoint);
                getAllGiftsProductCount(allGiftsCountEndpoint);
                //console.log('REplaced URL: ' + allGiftsCountEndpoint);
            } else if (filterUrl.includes('all-gifts')) {
                var mostGiftableCountEndpoint = filterUrl.replace(
                    'all-gifts',
                    'most-popular-gifts',
                );
                //console.log('Replaced URL: ' + mostGiftableCountEndpoint);
                getMostGiftableProductCount(mostGiftableCountEndpoint);
            }

            giftFinderPLPElements(productContents, filterUrl);
        })
        .catch((errorMsg) => {
            console.error('Error fetching filtered products:', errorMsg);
        });
}
// Function to handle filter change events
function onFilterChange() {
    // Toggle the 'manually-filtered' class based on whether a non-default option is selected
    $(this).toggleClass('manually-filtered', this.value !== '');
    setTimeout(function () {
        refreshTopTen(); // Refresh products with the new filters
    }, 100);
}

// Attach the filter change event handler to all filter dropdowns
$('.featured-collection-filters select').on('change', onFilterChange);

function scrollToTopStickyFinderMobile() {
    window.scrollTo({
        top: 210,
        left: 0,
        behavior: 'smooth',
    });
}

function scrollToTopStickyFinderDesktop() {
    window.scrollTo({
        top: 130,
        left: 0,
        behavior: 'smooth',
    });
}

$(document).on(
    'click',
    '.fake-select-dropdown li:not(.featured-collection-selected-filter)',
    function () {
        // Get the data-tag of the clicked option
        var selectedTag = $(this).attr('data-tag');
        var selectedTagDisplayText = $(this).attr('data-display-text');
        var selectIndex = $(this)
            .parents('.fake-select-dropdown')
            .attr('data-select-dropdown-index');

        //console.log('Select index:', selectIndex);

        //console.log('Selected tag:', selectedTag); // Check the value of selectedTag

        // Find the associated real select dropdown
        // Assuming that the real select dropdown is in the same 'li' as the fake dropdown
        var realSelect = $(
            '.featured-collection-filter-wrapper .featured-collection-filter-group[data-filter-group-index="' +
                selectIndex +
                '"]',
        ).find('select');

        // Update the real select dropdown
        realSelect.val(selectedTag); // Trigger the change event on the real select
        //console.log('Value of dropdown after setting:', realSelect.val()); // Check the value right after setting

        $(
            '.featured-collection-filter-wrapper .featured-collection-filter-group[data-filter-group-index="' +
                selectIndex +
                '"]',
        )
            .find('select')
            .trigger('change');

        //console.log('Change event triggered');

        // Optionally, update the custom dropdown to reflect the selection
        $(this)
            .parents('.fake-select-dropdown')
            .find('.featured-collection-selected-filter')
            .html($(this).html());
        $('.fake-select-dropdown[data-select-dropdown-index="' + selectIndex + '"]')
            .find('.featured-collection-selected-filter')
            .attr('data-tag', selectedTag);
        $('.fake-select-dropdown[data-select-dropdown-index="' + selectIndex + '"]')
            .find('.featured-collection-selected-filter')
            .attr('data-display-text', selectedTagDisplayText);

        $('.fake-select-dropdown[data-select-dropdown-index="' + selectIndex + '"]')
            .find('li:not(.featured-collection-selected-filter)')
            .removeClass('featured-collection-active-filter-hide');
        $('.fake-select-dropdown[data-select-dropdown-index="' + selectIndex + '"]')
            .find('li[data-tag="' + selectedTag + '"]:not(.featured-collection-selected-filter)')
            .addClass('featured-collection-active-filter-hide');

        if ($(this).hasClass('blank-filter')) {
            $(
                '.fake-select-dropdown[data-select-dropdown-index="' + selectIndex + '"]',
            ).removeClass('manually-filtered-dropdown');
            $('.fake-select-dropdown[data-select-dropdown-index="' + selectIndex + '"]')
                .find('.featured-collection-selected-filter')
                .addClass('no-option-selected');
        } else {
            $(
                '.fake-select-dropdown[data-select-dropdown-index="' + selectIndex + '"]',
            ).addClass('manually-filtered-dropdown');
            $('.fake-select-dropdown[data-select-dropdown-index="' + selectIndex + '"]')
                .find('.featured-collection-selected-filter')
                .removeClass('no-option-selected');

            $('body:not(.template-index) .fake-filter-slider').slick('unslick');

            $(
                '.fake-select-dropdown[data-select-dropdown-index="' +
                    selectIndex +
                    '"] li:not(.featured-collection-selected-filter)',
            ).removeClass('featured-collection-active-filter-hide');
            $('.fake-select-dropdown[data-select-dropdown-index="' + selectIndex + '"]')
                .find(
                    'li[data-tag="' +
                        selectedTag +
                        '"]:not(.featured-collection-selected-filter)',
                )
                .addClass('featured-collection-active-filter-hide');
        }

        if (
            $(this)
                .parents('.featured-collection-filters')
                .parent()
                .hasClass('sticky-gift-finder')
        ) {
            $(
                '.featured-collection-filter-wrapper .fake-select-dropdown[data-select-dropdown-index="' +
                    selectIndex +
                    '"] .featured-collection-selected-filter',
            ).html(
                $(
                    '.featured-collection-filter-wrapper .fake-select-dropdown[data-select-dropdown-index="' +
                        selectIndex +
                        '"] li[data-tag="' +
                        selectedTag +
                        '"]:not(.featured-collection-selected-filter)',
                ).html(),
            );
            $(
                '.featured-collection-filter-wrapper .fake-select-dropdown[data-select-dropdown-index="' +
                    selectIndex +
                    '"]',
            )
                .find('.initial-filter-load')
                .removeClass('initial-filter-load');
            scrollToTopStickyFinderMobile();
        } else {
            $(
                '.sticky-gift-finder .fake-select-dropdown[data-select-dropdown-index="' +
                    selectIndex +
                    '"] .featured-collection-selected-filter',
            ).html(
                $(
                    '.sticky-gift-finder .fake-select-dropdown[data-select-dropdown-index="' +
                        selectIndex +
                        '"] li[data-tag="' +
                        selectedTag +
                        '"]:not(.featured-collection-selected-filter)',
                ).html(),
            );
            $(
                '.sticky-gift-finder .fake-select-dropdown[data-select-dropdown-index="' +
                    selectIndex +
                    '"]',
            )
                .find('.initial-filter-load')
                .removeClass('initial-filter-load');

            if ($(window).width() > 990 && $('body').hasClass('show-gift-finder')) {
                scrollToTopStickyFinderDesktop();
            }
        }
    },
);

$(document).on(
    'click',
    '.fake-select-dropdown .featured-collection-selected-filter',
    function () {
        $('.template-index .fake-filter-slider').slick('slickPause');
        $('.featured-collection-filters select').each(function () {
            $(this).addClass('manually-filtered');
        });
    },
);

$(document).on('click', '.featured-collection-filter-group.fake-select-open li', function () {
    $(this)
        .parents('.fake-select-dropdown')
        .find('.initial-filter-load')
        .removeClass('initial-filter-load');
});

$(document).on('click', '.fake-select-open .fake-select-dropdown', function () {
    var $this = $(this);
    $this.parents('.featured-collection-filter-group').addClass('fake-select-closing');
    $this.parents('.featured-collection-filter-group').removeClass('fake-select-open');
    setTimeout(function () {
        $this.parents('.featured-collection-filter-group').removeClass('fake-select-closing');
    }, 800);
});

$(document).on(
    'click',
    '.featured-collection-filter-group:not(.fake-select-open) .fake-select-dropdown, .featured-collection-filter-group:not(.fake-select-open) .toggle-select-dropdown',
    function () {
        var $this = $(this);
        $('.featured-collection-filter-group').removeClass('fake-select-open');

        $this.parents('.featured-collection-filter-group').addClass('fake-select-open');
    },
);

function clickGO() {
    $('.go-gg-trigger')[0].click();
}

// Click event handler for the "Go" button
$('.go-gg-trigger').on('click', function () {
    // Construct the filter URL
    var goUrl = constructGoButtonUrl();
    // Redirect the user to the constructed URL
    //refreshGiftFinder(goUrl);
});

// Click event for dropdowns
$(document).on('click', '.fake-select-dropdown', function () {
    $('body').addClass('fake-select-clicked');
});

$(document).on('click', function (event) {
    // Check if the clicked area is not within an open dropdown
    if (!$(event.target).closest('.fake-select-open').length) {
        // Close all open dropdowns
        $('.featured-collection-filter-group').addClass('fake-select-closing');
        $('.featured-collection-filter-group').removeClass('fake-select-open');

        setTimeout(function () {
            $('.featured-collection-filter-group').removeClass('fake-select-closing');
        }, 800);
    }
});

$(document).on(
    'click',
    '.featured-collection-filter-group.fake-select-open label',
    function (e) {
        e.preventDefault();
        var $this = $(this);
        $this.parents('.featured-collection-filter-group').addClass('fake-select-closing');
        $this.parents('.featured-collection-filter-group').removeClass('fake-select-open');
        setTimeout(function () {
            $this
                .parents('.featured-collection-filter-group')
                .removeClass('fake-select-closing');
        }, 800);
    },
);

$(document).on('click', '.fake-select-open .toggle-select-dropdown', function (e) {
    var $this = $(this);
    $this.parents('.featured-collection-filter-group').addClass('fake-select-closing');
    $this.parents('.featured-collection-filter-group').removeClass('fake-select-open');
    setTimeout(function () {
        $this.parents('.featured-collection-filter-group').removeClass('fake-select-closing');
    }, 800);
});

document.addEventListener('DOMContentLoaded', () => {
    // Function to initialize tickers, skipping already initialized ones
    function initializeTickers() {
      // Only select tickers that haven't been initialized
      const tickers = document.querySelectorAll('.brand-block-ticker:not(.brand-block-ticker-initialized)');
      
      tickers.forEach(ticker => {
        const track = ticker.querySelector('.ticker-track');
        const items = track.querySelectorAll('.ticker-item');
        const firstSetCount = 3; // First three messages for 5 total, restarting at 4th (first repeat)
        const lastUniqueItem = items[firstSetCount - 1]; // Last item of first set (3rd message)
        const scrollDistance = lastUniqueItem.offsetLeft + lastUniqueItem.offsetWidth + 5;
  
        track.style.setProperty('--scroll-distance', `-${scrollDistance}px`);
        ticker.classList.add('brand-block-ticker-initialized');
      });
      
      // Check for already initialized tickers with unrealistic scroll distances
      fixBrokenTickers();
    }
    
    // Function to find and fix tickers with unrealistically small scroll distances
    function fixBrokenTickers() {
      const initializedTickers = document.querySelectorAll('.brand-block-ticker-initialized');
      
      initializedTickers.forEach(ticker => {
        const track = ticker.querySelector('.ticker-track');
        
        // Get the current scroll distance and parse it to a number
        const currentScrollDistance = getComputedStyle(track).getPropertyValue('--scroll-distance');
        const scrollDistanceValue = parseInt(currentScrollDistance);
        
        // Check if scroll distance is too small (likely calculated when hidden)
        if (scrollDistanceValue > -20) { // If less than 20px, it's probably wrong
          // Check if the ticker is now visible
          const isVisible = ticker.offsetWidth > 0 && ticker.offsetHeight > 0;
          
          if (isVisible) {
            // Reinitialize this specific ticker
            ticker.classList.remove('brand-block-ticker-initialized');
            
            // Get ticker items and calculate proper distance
            const items = track.querySelectorAll('.ticker-item');
            const firstSetCount = 3;
            const lastUniqueItem = items[firstSetCount - 1];
            const scrollDistance = lastUniqueItem.offsetLeft + lastUniqueItem.offsetWidth + 5;
            
            track.style.setProperty('--scroll-distance', `-${scrollDistance}px`);
            ticker.classList.add('brand-block-ticker-initialized');
          }
        }
      });
    }
  
    // Function to reset and recalculate all tickers
    function recalculateAllTickers() {
      // Find all initialized tickers
      const initializedTickers = document.querySelectorAll('.brand-block-ticker-initialized');
      
      // Remove initialized class so they'll be recalculated
      initializedTickers.forEach(ticker => {
        ticker.classList.remove('brand-block-ticker-initialized');
      });
      
      // Reinitialize
      initializeTickers();
    }
  
    // Initial call on load
    initializeTickers();
  
    // Debounced resize handler
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(initializeTickers, 250);
    });
    
    // Listen for pagination content loaded events
    document.addEventListener('paginationContentLoaded', function(event) {
      // First check if any existing tickers need fixing immediately
      setTimeout(fixBrokenTickers, 100);
      
      // Then do a full recalculation after a longer delay
      setTimeout(() => {
        recalculateAllTickers();
      }, 500);
    });
    
    // Make functions available globally
    window.initializeTickers = initializeTickers;
    window.recalculateAllTickers = recalculateAllTickers;
    window.fixBrokenTickers = fixBrokenTickers;
  });